var map = {
	"./3dcart.svg": "uTbl",
	"./adyen.svg": "k687",
	"./aftership.svg": "YRG8",
	"./api.svg": "HMa5",
	"./berkhof-digital.svg": "d54a",
	"./bigcommerce.svg": "9ysO",
	"./bss-commerce.svg": "1b3P",
	"./carriboo.svg": "U2aJ",
	"./dhl.svg": "x3QZ",
	"./dropship-3d-cart.svg": "mj+l",
	"./dropship-api.svg": "D2EN",
	"./dropship-big-cartel.svg": "52Yp",
	"./dropship-big-commerce.svg": "doss",
	"./dropship-csv-or-xml.svg": "2Fdt",
	"./dropship-etsy.svg": "/Ief",
	"./dropship-magento.svg": "BmN3",
	"./dropship-opencart.svg": "jTA/",
	"./dropship-prestashop.svg": "bYQv",
	"./dropship-selz.svg": "vC2o",
	"./dropship-shipstation.svg": "ddj2",
	"./dropship-shopify.svg": "u8rY",
	"./dropship-squarespace.svg": "SH2z",
	"./dropship-tradegecko.svg": "Ceyc",
	"./dropship-woo-commerce.svg": "Rwc6",
	"./dropship-woocommerce.svg": "qb9A",
	"./easypost.svg": "juzp",
	"./elastic-path.svg": "fred",
	"./endicia.svg": "KvRg",
	"./etsy.svg": "X3DW",
	"./google-drive.svg": "IUcd",
	"./intercom.svg": "4KNS",
	"./jetti.svg": "bPvJ",
	"./lob.svg": "iCZ+",
	"./magento-alt.svg": "8yHd",
	"./magento.svg": "daeG",
	"./mailgun.svg": "2k9O",
	"./marketplace-studio.svg": "OV6+",
	"./metrimax.svg": "okXT",
	"./onport.svg": "nc/M",
	"./opencart.svg": "T8Z9",
	"./patchworks.svg": "ZfUv",
	"./paypal.svg": "pNSw",
	"./prestashop.svg": "9YFc",
	"./quickbooks.svg": "6tJg",
	"./royal-mail.svg": "Zc4G",
	"./saleor.svg": "Qyfi",
	"./salesforce.svg": "ruPT",
	"./seltz.svg": "YWXM",
	"./shipping-portal.svg": "51gv",
	"./shippo.svg": "dSA6",
	"./shippypro.svg": "c+Km",
	"./shipstation.svg": "hJix",
	"./shopbox-ai.svg": "QljA",
	"./shopify-alt.svg": "2NL6",
	"./shopify.svg": "fl/T",
	"./slack.svg": "T9VW",
	"./squarespace.svg": "qmbY",
	"./stripe.svg": "8f/8",
	"./taxjar.svg": "t5xj",
	"./tradegecko.svg": "vlOu",
	"./transferwise.svg": "Puey",
	"./usps.svg": "1WI6",
	"./vendor-integration-channelengine.svg": "XhGA",
	"./vendor-portal.svg": "djDU",
	"./wise.svg": "oAQs",
	"./wix.svg": "irde",
	"./woocommerce.svg": "TQJK",
	"./xero.svg": "aSqV",
	"./zapier.svg": "wqSx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "o/tq";